import { isBrowsingWithoutOrderFlowLocale } from '@/core/constants/browse-only-resolution';

export type BffCatalogProductsQueryParams = {
  countryCode: string;
  languageCode: string;
  includeAvailability: boolean;
};

export type BffCatalogSubscriptionsQueryParams = {
  countryCode: string;
  languageCode: string;
  hasAccessToken: boolean;
};

export const bffCatalogProductsQueryKey = (
  params: BffCatalogProductsQueryParams,
) =>
  [
    'bff-catalog-products',
    params.countryCode,
    params.languageCode,
    params.includeAvailability,
  ] as const;

export const bffCatalogSubscriptionsQueryKey = (
  params: BffCatalogSubscriptionsQueryParams,
) =>
  [
    'bff-catalog-subscriptions',
    params.countryCode,
    params.languageCode,
    params.hasAccessToken,
  ] as const;

/** BFF catalog is only available for EVA-registered markets. */
export function isBffCatalogEnabledForLocale(
  locale: string,
  evaCountryIds?: readonly string[],
): boolean {
  return !isBrowsingWithoutOrderFlowLocale(locale, evaCountryIds);
}

/** Next-intl locale e.g. `en-nl` → BFF catalog params (country required by API). */
export function localeToBffCatalogParams(locale: string): {
  countryCode: string;
  languageCode: string;
} {
  const [language = 'en', country = ''] = locale.split('-');
  const countryCode = (country || 'NL').toUpperCase();
  const languageCode = language || 'en';
  return { countryCode, languageCode };
}
